/**
 * "First Last" from two optional name parts — blanks trimmed and dropped.
 * Returns `null` when neither part carries text so callers choose their
 * own empty treatment (the listing shows the N/A sentinel, the detail
 * sheet falls back to the listing row's name).
 */
export function joinName(
  first: string | null | undefined,
  last: string | null | undefined,
): string | null {
  const parts = [first, last]
    .map((p) => (typeof p === 'string' ? p.trim() : ''))
    .filter((p) => p !== '');
  return parts.length > 0 ? parts.join(' ') : null;
}
